import { getDeviceStatusLabel } from '@cobliteam/common-types';

import type { DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';

import { Checkbox } from '@cobliteam/base-components/src/SelectionControls/Checkbox';

interface DeviceStatusItemProps {
  checked: boolean;
  status: DeviceGeneralStatus;
  count: number | null;
  onChange: () => void;
}

const DeviceStatusItem = ({
  checked,
  count,
  status,
  onChange,
}: DeviceStatusItemProps) => {
  const statusLabel = getDeviceStatusLabel(status);

  const label = `${statusLabel} (${count})`;

  return (
    <Checkbox
      key={`device-${status}`}
      checked={checked}
      onChange={onChange}
      label={label}
    />
  );
};
export default DeviceStatusItem;
